// extracted by mini-css-extract-plugin
export var quantityInput = "_h5-0";